import { BaseFetch } from "../main-model"
export default class LearningResModel extends BaseFetch {
  getLearningResBy = (data) =>
    this.authFetch({
      url: "learning-res/getLearningResBy",
      method: "POST",
      body: JSON.stringify(data),
    })
  getLearningResById = (data) =>
    this.authFetch({
      url: "learning-res/getLearningResById",
      method: "POST",
      body: JSON.stringify(data),
    })
    updateLearningResById = (data) =>
    this.authFetch({
      url: "learning-res/updateLearningResById",
      method: "POST",
      body: JSON.stringify(data),
    })
    insertLearningRes = (data) =>
    this.authFetch({
      url: "learning-res/insertLearningRes",
      method: "POST",
      body: JSON.stringify(data),
    })
    deleteLearningResById = (data) =>
    this.authFetch({
      url: "learning-res/deleteLearningResById",
      method: "POST",
      body: JSON.stringify(data),
    })
}
